import React from "react";
import Typography from "@mui/material/Typography";
import Parceiro from "../../components/classes/Parceiro";

import { useTranslation } from "react-i18next";

export default function EstoqueParceiroTopo(props: EstoqueParceiroTopoPropsTypes) {
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <div className="containerTitle">
        <Typography
          variant="h5"
          fontFamily={"Co Headline Regular"}
          gutterBottom
          align="left"
          marginLeft="15px"
        >
          {t("pages.stockPartnerNamed.pageTitle")} {props.parceiro?.nome || "..."}
        </Typography>
      </div>
    </React.Fragment>
  );
}

interface EstoqueParceiroTopoPropsTypes {
  parceiro: Parceiro;
}